import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import Tooltip from './Tooltip';
import './Input.css';

interface IProps {
	id: string;
	value: number | null;
	onChange: (fieldName: string, value: number | null) => void;
	className?: string;
	name: string;
	label?: React.ReactNode;
	tooltip?: React.ReactNode;
	type?: "string";
	disabled?: boolean;
	error?: string | null | undefined;
	errorParams?: Record<string, unknown> | null | undefined;
}

const Input: React.FC<IProps> = (props: IProps) => {
	const { i18n } = useTranslation();
	const [displayValue, setDisplayValue] = useState<string>('');

	const getDecimalSeparator = (): string => {
		return i18n.language === 'ru' ? ',' : '.';
	};

	const formatNumber = (num: number | null): string => {
		if (num === null || isNaN(num)) return '';
		const separator = getDecimalSeparator();
		return num.toString().replace('.', separator);
	};

	const parseNumber = (str: string): number => {
		const normalized = str.replace(',', '.');
		return parseFloat(normalized);
	};

	useEffect(() => {
		setDisplayValue(formatNumber(props.value));
	}, [props.value, i18n.language]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const inputValue = e.target.value;
		const validInput = /^-?\d*[,.]?\d*$/;

		if (validInput.test(inputValue) || inputValue === '' || (inputValue === '-')) {
			setDisplayValue(inputValue);

			if (inputValue == "" || inputValue == null) {
				props.onChange(e.target.name, null);
			} else {
				const numValue = parseNumber(inputValue);
				if (!isNaN(numValue)) {
					props.onChange(e.target.name, numValue);
				}
			}
		}
	};
	const { t } = useTranslation();

	return (
		<div className={`field-wrapper ${props.className || ""} ${props.error ? "error" : ""}`}>
			<Tooltip content={props.tooltip}>
				<div className="input-wrapper">
					<input
						id={props.id}
						data-testid={props.id}
						type="text"
						inputMode="decimal"
						value={displayValue}
						onChange={handleChange}
						className="number-input"
						name={props.name}
						disabled={props.disabled}
					/>
					{props.error && (
						<span className="input-error">{t(props.error, props.errorParams ?? undefined)}</span>
					)}
				</div>
			</Tooltip>
		</div>
	)
}

export default Input